<div class="p-a-5 bg-col-w b-col-42 b-a flex _container">
    <div class="_progress"
         [class._completed]="isCompleted">
        @if (isCompleted) {
        <i class="icon-tick inline-flex _icon"></i>
        }
        <div class="_progressCircle"
             [style.--progress]="progressPercentage"></div>
    </div>
    <div class="flex-grow">
        <h4 class="p2">{{ mission.title | translate }}</h4>
        <div class="m-t-3 col-11 p2">
            @if(mission.points) {
            <span class="m-r-6">{{ '% Coins' | translate : mission.points }}</span>
            }
            @if(mission.rosettes) {
            <span class="m-r-6">{{ '% Rosettes' | translate : mission.rosettes }}
            </span>
            }

        </div>
    </div>

    <a [routerLink]="detailsLink"
       class="_button">
        <i style="font-size: 24px;"
           class="icon-arrow-simple-right inline-flex"></i>
    </a>
</div>
